import { ICellRendererParams } from 'ag-grid-community';
import { FC, useEffect } from 'react';
import { Placeholder } from 'rsuite';

const RedditReportLoadingCellRenderer: FC<ICellRendererParams> = ({ node, columnApi, api }) => {
	const cols = columnApi.getAllDisplayedColumns().map(col => col.getActualWidth());

	useEffect(() => {
		if (node.rowHeight !== 1600) {
			node.setRowHeight(1600);
			api.onRowHeightChanged();
		}
	}, []);

	return (
		<div>
			{
				Array(50).fill(null).map((_, key) => ((
					<div
						key={key}
						className="w-full flex border-b border-b-gray-300"
					>
						{
							cols.map((width, idx) => (
								<div
									key={idx}
									style={{ minWidth: width }}
									className="border-r px-[8px] border-r-gray-300 h-[31px] flex items-center"
								>
									<Placeholder.Graph
										active
										className="rounded-full"
										height={16}
									/>
								</div>
							))
						}
					</div>
				)))
			}
		</div>
	);
};

export default RedditReportLoadingCellRenderer;
